module.exports = "https://www.gc-pro.gnp.com.mx/56b20d9255f6e028fc0ac065320f1881.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/group_18.svg
// module id = 8111
// module chunks = 0